<script setup lang="ts">
import Img from '~/components/Img.vue';
import Modal from '~/components/Modal.vue';
import SmallButton from '~/components/SmallButton.vue';
import { APP_URL, RESULT_PAGE_PATH } from '~/constants';
import {
  SNS_INSTAGRAM_TEXT,
  SNS_INSTAGRAM_HASHTAG,
  SNS_SHARE_PAGE_TEXT,
} from '~/constants/sns';

type Props = {
  url: string;
};
const props = defineProps<Props>();
const { path, query } = useRoute();

const isOpenToast = ref(false);
const showToast = () => {
  isOpenToast.value = true;
  setTimeout(() => {
    hideToast();
  }, 1500);
};
const hideToast = () => {
  isOpenToast.value = false;
};

const isResultPage = computed(() => path === RESULT_PAGE_PATH.NORMAL);
// 結果画面かつクエリパラメータが揃っている場合に動的なOGP画像を表示する
const isShowLambdaOgpImage = computed(
  () =>
    isResultPage.value &&
    query.score &&
    query.ranking &&
    query.level &&
    query.name,
);
/**
 * モーダル内でコピーする対象
 */
const copyText = computed(() => {
  if (!isResultPage.value)
    return SNS_INSTAGRAM_TEXT + '\n' + SNS_INSTAGRAM_HASHTAG + '\n' + props.url;
  return SNS_SHARE_PAGE_TEXT + '\n' + SNS_INSTAGRAM_HASHTAG + '\n' + props.url;
});

const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
  showToast();
};
</script>

<template>
  <Modal>
    <template #trigger>
      <slot name="trigger" />
    </template>
    <template #header>
      <Img
        src="/images/modal/instagram_share_modal_header_text.svg"
        alt="Instagramでシェアする"
        :width="201"
      />
    </template>
    <template #body>
      <div>
        <p>画像を長押ししてスマートフォンに保存してください</p>
        <p class="mb-3 text-xs">(PCの場合は右クリックして保存してください)</p>
        <img
          v-if="isShowLambdaOgpImage"
          :src="`${APP_URL}/ogp/${query.score}/${query.ranking}/${query.level}/${query.name}`"
          alt="OGP"
        />
        <img v-else src="/ogp.png" alt="OGP" />
      </div>
      <div v-if="isOpenToast" class="toast">コピーしました</div>
      <p class="mt-4">以下の文言をコピーして投稿してください</p>
      <div class="mt-4 bg-[#E1DFE0] p-[22px]">
        <p class="whitespace-pre-wrap break-words text-xs leading-5">
          {{ copyText }}
        </p>
        <div class="mt-2 flex justify-center">
          <SmallButton variant="copy" @click="copyToClipboard(copyText)" />
        </div>
      </div>
    </template>
  </Modal>
</template>

<style scoped>
.toast {
  position: fixed;
  top: 340px;
  left: calc(50% - 76px);
  width: 152px;
  padding: 8px 16px;
  color: #333;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
}
</style>
